module.exports = __webpack_public_path__ + "img/title-en.23e776ed.png";